// frontend/shared-ui/src/forms/fields/SelectField.jsx
import React from "react";

export default function SelectField({ field, value, onChange, error }) {
  const inputId = `field-${field.key}`;
  const opts = field.options || [];

  return (
    <div className="fh-form-field">
      <label
        htmlFor={inputId}
        className={`fh-form-field__label ${field.required ? "is-required" : ""}`}
      >
        {field.label}
      </label>
      <select
        id={inputId}
        className={`fh-input ${error ? "is-invalid" : ""}`}
        value={value ?? ""}
        onChange={(e) => onChange(e.target.value)}
        disabled={field.disabled}
      >
        <option value="">— Select {field.label.toLowerCase()} —</option>
        {opts.map((o) => {
          const v = typeof o === "object" ? o.value : o;
          const l = typeof o === "object" ? o.label : o;
          return (
            <option key={v} value={v}>
              {l}
            </option>
          );
        })}
      </select>
      {field.hint && <div className="fh-form-field__hint">{field.hint}</div>}
      {error && <div className="fh-form-field__error">{error}</div>}
    </div>
  );
}
